// extracted by mini-css-extract-plugin
export default {"aboutToggle":"AboutSectionWrapper_aboutToggle__pRNm1","active":"AboutSectionWrapper_active__pi8PF","pulse":"AboutSectionWrapper_pulse__CwEBR"};